// react-native-camera -> getUserMedia + BarcodeDetector (where available)
import React from "react";
import { View, Text } from "react-native-web";

export default class Camera extends React.Component {
  static constants = {
    Aspect: { fill: "fill", fit: "fit", stretch: "stretch" },
    CaptureTarget: { disk: "disk", memory: "memory", temp: "temp" },
    Type: { back: "back", front: "front" },
    BarCodeType: {},
  };

  state = { error: null };

  componentDidMount() {
    this.mounted = true;
    this.start();
  }

  componentWillUnmount() {
    this.mounted = false;
    this.stop();
  }

  async start() {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      this.setState({ error: "Camera is not available in this browser." });
      return;
    }
    try {
      const facingMode = this.props.type === "front" ? "user" : "environment";
      this.stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode },
        audio: false,
      });
      if (!this.mounted) {
        this.stop();
        return;
      }
      this.video.srcObject = this.stream;
      await this.video.play();
    } catch (e) {
      this.setState({ error: "Unable to open the camera: " + e.message });
      return;
    }

    if (!("BarcodeDetector" in window)) {
      this.setState({
        error:
          "Barcode scanning is not supported by this browser. Type the barcode or use a USB/Bluetooth scanner.",
      });
      return;
    }
    this.detector = new window.BarcodeDetector();
    this.timer = setInterval(() => this.scan(), 350);
  }

  async scan() {
    if (!this.video || this.video.readyState < 2 || this.busy) {
      return;
    }
    this.busy = true;
    try {
      const codes = await this.detector.detect(this.video);
      if (codes.length && this.props.onBarCodeRead && this.mounted) {
        const now = Date.now();
        const value = codes[0].rawValue;
        if (value !== this.lastValue || now - this.lastTime > 1500) {
          this.lastValue = value;
          this.lastTime = now;
          this.props.onBarCodeRead({ data: value, type: codes[0].format });
        }
      }
    } catch (e) {
      // frame could not be read, try again on the next tick
    }
    this.busy = false;
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
      this.stream = null;
    }
  }

  render() {
    return (
      <View style={[{ minHeight: 240, backgroundColor: "#000" }, this.props.style]}>
        <video
          ref={node => {
            this.video = node;
          }}
          muted
          playsInline
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
        {this.state.error ? (
          <Text
            style={{
              color: "#fff",
              backgroundColor: "rgba(0,0,0,.6)",
              padding: 10,
              margin: 10,
            }}
          >
            {this.state.error}
          </Text>
        ) : null}
        {this.props.children}
      </View>
    );
  }
}
